// React
import React from 'react';
// Refine
import { useThemedLayoutContext } from '@refinedev/mantine';
// Mantine
import { Tooltip, ActionIcon } from '@mantine/core';
import { useHotkeys } from '@mantine/hooks';
// Icons
import {
  IconCircleArrowLeftFilled,
  IconCircleArrowRightFilled,
  IconMenu2,
} from '@tabler/icons-react';
// Auth
import { useIsAdmin } from 'hooks/useIsAdmin';
import { useSiderStore } from 'store/SiderStore';
import { useIsMobile } from 'hooks/useIsMobile';

export const HamburgerMenu: React.FC = () => {
  useHotkeys([['[', () => toggleSider(!isMobile)]]);

  const { setSiderCollapsed, mobileSiderOpen, setMobileSiderOpen } =
    useThemedLayoutContext();

  const isAdmin = useIsAdmin();
  const isMobile = useIsMobile(700);

  const { isCollapsed, setIsCollapsed } = useSiderStore();

  const toggleSider = (matches: boolean) => {
    if (matches) {
      setSiderCollapsed(!isCollapsed);
      setIsCollapsed(!isCollapsed);
    } else {
      setMobileSiderOpen(!mobileSiderOpen);
    }
  };

  const commonStyle = {
    position: 'absolute' as const,
    top: '6rem',
    left: isCollapsed ? '2.25rem' : '11.65rem',
    border: 'none',
    zIndex: 250,
  };

  return (
    <>
      {!isMobile ? (
        <Tooltip label={isCollapsed ? 'Expand' : 'Collapse'} position="right">
          <ActionIcon
            variant="subtle"
            color={isAdmin ? 'gray' : 'blue'}
            style={commonStyle}
            onClick={() => {
              toggleSider(!isMobile);
            }}
            className="hamburger-menu"
          >
            {isCollapsed ? (
              <IconCircleArrowRightFilled size={25} />
            ) : (
              <IconCircleArrowLeftFilled size={25} />
            )}
          </ActionIcon>
        </Tooltip>
      ) : (
        <>
          <ActionIcon
            variant="subtle"
            color={isAdmin ? 'gray' : 'blue'}
            style={commonStyle}
            onClick={() => toggleSider(isMobile)}
          >
            <IconMenu2 size={20} />
          </ActionIcon>
        </>
      )}
    </>
  );
};
